<div class="container-fluid">
  <div class="mb-4">
    <h1 class="page-title">Workflow Acompanhamento</h1>
    <p class="text-muted">Visualize as ordens de servico por etapa.</p>
  </div>

  <div class="panel mb-4">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-4">
        <label class="form-label">Status</label>
        <select class="form-select" [(ngModel)]="filterStatus" (change)="applyFilters()">
          <option value="TODOS">Todos</option>
          <option value="EM_ANDAMENTO">Em andamento</option>
          <option value="ATRASADO">Atrasado</option>
        </select>
      </div>
      <div class="col-12 col-md-4">
        <label class="form-label">Placa do veiculo</label>
        <input class="form-control" [(ngModel)]="filterPlaca" (input)="applyFilters()" />
      </div>
      <div class="col-12 col-md-4">
        <div class="text-muted small">Clique em um card para abrir o detalhe.</div>
      </div>
    </div>
  </div>

  <div class="workflow-board__columns" style="max-height: 500px !important">
    <div class="workflow-column" *ngFor="let etapa of etapas; trackBy: trackByEtapa">
      <div
        class="workflow-column__header"
        [ngStyle]="{ 'background-color': getStageColor(etapa.tipo) }"
      >
        <h3 class="workflow-column__title">{{ etapa.nome }}</h3>
        <span class="workflow-column__count">{{ getGroupedWorkflows(etapa.tipo).length }}</span>
      </div>
      <div
        class="workflow-column__cards"
        cdkDropList
        [id]="dropListId(etapa.tipo)"
        [cdkDropListData]="getGroupedWorkflows(etapa.tipo)"
        [cdkDropListConnectedTo]="connectedDropListsIds"
        (cdkDropListDropped)="onDrop($event, etapa.tipo)"
      >
        <button
          type="button"
          class="workflow-card"
          *ngFor="let workflow of getGroupedWorkflows(etapa.tipo)"
          [ngStyle]="{ 'border-left-color': getStageColor(etapa.tipo) }"
          (click)="onSelectWorkflow(workflow)"
          cdkDrag
        >
          <div class="workflow-card__row workflow-card__row--headline">
            <span class="workflow-card__number">{{ formatOsNumero(workflow) }}</span>
            <span class="workflow-card__date">
              {{ getDataAbertura(workflow) | date: 'dd/MM/yyyy' }}
            </span>
          </div>
          <div class="workflow-card__row workflow-card__row--sub">
            <span class="workflow-card__label">Prevista</span>
            <span class="workflow-card__value">
              {{ getDataPrevista(workflow) | date: 'dd/MM/yyyy' }}
            </span>
          </div>
          <div class="workflow-card__row">
            <span class="workflow-card__label">Veículo</span>
            <span class="workflow-card__value">{{ getVeiculoLabel(workflow) }}</span>
          </div>
          <div class="workflow-card__row">
            <span class="workflow-card__label">Cliente</span>
            <span class="workflow-card__value">{{ workflow.clienteNome }}</span>
          </div>
          <div class="workflow-card__row">
            <span class="workflow-card__label">Responsável</span>
            <span class="workflow-card__value">{{ workflow.responsavelAtual }}</span>
          </div>
          <div class="workflow-card__footer">
            <span
              class="workflow-chip"
              [class.workflow-chip--late]="workflow.statusGeral === 'ATRASADO'"
              [class.workflow-chip--ok]="workflow.statusGeral !== 'ATRASADO'"
            >
              {{ workflow.statusGeral === 'ATRASADO' ? 'Em atraso' : 'Em andamento' }}
            </span>
          </div>
        </button>
        <div class="workflow-column__empty" *ngIf="!getGroupedWorkflows(etapa.tipo).length">
          Sem itens nesta etapa.
        </div>
      </div>
    </div>
  </div>
</div>
